
import { Box, BoxList, Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import ArchiveItem from 'modules/locations/components/ArchivedItem'
import { WorkAreaNode } from 'modules/locations/hooks/useWorkAreas'

interface Props {
  workArea: WorkAreaNode
  unarchiveWorkArea: (workArea: WorkAreaNode) => void
}

const ArchivedWorkAreaItem = ({ workArea, unarchiveWorkArea }: Props) => {
  return (
    <BoxList.Item>
      <Box width="full">
        <ArchiveItem name={workArea.name}>
          <Button
            onClick={() => unarchiveWorkArea(workArea)}
            type="secondary"
            iconName="archive-open"
          />
        </ArchiveItem>
      </Box>
    </BoxList.Item>
  )
}

export default observer(ArchivedWorkAreaItem)
